module.exports = __webpack_public_path__ + "assets/images/25L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25L.png
// module id = 1297
// module chunks = 1